import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import queryString from "query-string";
import axios from "axios";
import { io } from "socket.io-client";

const Container = styled.div`
  background-color: #222222;
  background-repeat: no-repeat;
  background-size: cover;
  overflow-x: hidden;
  color: white;
  font-family: "Oxanium";
  min-height: 100vh;
  overflow-y: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  .example::-webkit-scrollbar {
    display: none;
  }
  font-family: "Oxanium-SemiBold";
  display: flex;
  flex-direction: column;
`;

const SubContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  border-width: 1px;
  border-radius: 12px;
  border-color: #606060;
  border-style: solid;
  padding: 10px;
`;

const LeftImageBlock = styled.div`
  min-height: 688px;
  min-width: 289px;
  background-repeat: no-repeat;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  z-index: 2;
  position: relative;
`;

const RightBlock = styled.div`
  flex: 1;
  min-height: 688px;
  max-height: 688px;
  min-width: 70%;
  background-color: rgba(31, 31, 31, 75%);
  margin-left: -50px;
  border-radius: 12px;
`;

const LinkDiv = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  a {
    text-decoration: none;
    cursor: pointer;
    color: #fff;
  }
`;

export const LeaderBoard = () => {
  const [savedResults, setSavedResults] = useState([]);
  const [lastResult, setLastResult] = useState(undefined);
  const [fastestDuration, setFastestDuration] = useState(0);
  const [lastIndex, setLastIndex] = useState(0);

  useEffect(() => {
    const teamId = queryString.parse(window.location.search).teamId;
    const workoutId = queryString.parse(window.location.search).workoutId;
    const from = queryString.parse(window.location.search).from;

    async function getSaved(teamId, workoutId) {
      const fetchedResults = await axios.get(
        `https://${
          queryString.parse(window.location.search)?.env === "prod"
            ? ""
            : "dev."
        }api.sportreact.com/api/v1/workouts/${workoutId}/team/${teamId}/sessions${
          from ? `?from=${from}` : ""
        }`
      );
      if (
        fetchedResults.status === 200 &&
        typeof fetchedResults.data === "object"
      ) {
        console.log(fetchedResults.data);
        setSavedResults(fetchedResults.data);
      }
      const socket = io.connect(
        // `${window.location.protocol}//${window.location.hostname}`
        queryString.parse(window.location.search)?.env === "prod"
          ? "https://api.sportreact.com"
          : "https://dev.api.sportreact.com"
      );
      socket.on("connection_error", (err) => {
        console.log("server error", err);
      });
      socket.on(`${teamId}_${workoutId}`, (data) => {
        console.log("stigo");
        setSavedResults((prevResults) => {
          const ids = prevResults.map((res) => res.id);
          const newData = [];
          data.forEach((input) => {
            if (!ids.includes(input.id)) {
              newData.push(input);
            }
          });
          return [...prevResults, ...newData];
        });
        setLastResult(data[0]);
      });
      socket.on("events", (data) => {
        console.log(data);
      });
    }

    getSaved(teamId, workoutId);
  }, []);

  const dispalyResults = useMemo(() => {
    if (savedResults?.length === 0) return [];
    const sortedResults = savedResults?.sort((a, b) => a.duration - b.duration);
    const lastResultIndex = savedResults?.findIndex(
      (res) => res.id === lastResult?.id
    );
    setLastIndex(lastResultIndex);
    setFastestDuration(sortedResults[0].duration);
    return sortedResults;
  }, [savedResults, lastResult]);

  const variableParams = useMemo(() => {
    return queryString.parse(window.location.search);
  }, []);

  return (
    <Container
      style={{
        backgroundImage: variableParams.background
          ? variableParams.background.includes("http")
            ? `url(${variableParams.background})`
            : `url(/${variableParams.background}.png)`
          : "url(/generic-bg.png)",
      }}
    >
      <SubContainer>
        <LeftImageBlock
          style={{
            backgroundImage: variableParams.sideBackground
              ? variableParams.sideBackground.includes("http")
                ? `url(${variableParams.sideBackground})`
                : `url(/${variableParams.sideBackground}.png)`
              : "url(/side-bg.png)",
          }}
        >
          <div
            style={{
              width: "277px",
              height: "676px",
              borderRadius: "15px",
              borderStyle: "solid",
              borderColor: "#606060",
              alignSelf: "center",
              margin: 5,
              borderWidth: "1px",
            }}
          >
            <p
              style={{
                fontSize: "40px",
                position: "relative",
                bottom: "-400px",
                margin: "5px",
              }}
            >
              <span>{variableParams.sideTopText ?? "Are you faster than"}</span>
              <br />
              <span style={{ color: "#ffeb32", fontSize: "58px" }}>
                {variableParams.sideBottomText ?? "MRGUD?"}
              </span>
            </p>
          </div>
        </LeftImageBlock>
        <RightBlock>
          <div
            style={{
              marginLeft: "75px",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <span style={{ fontFamily: "Oxanium-Bold", fontSize: "24px" }}>
                  {variableParams.title ?? "FNC reaciton time challenge"}
                </span>
                <br />
                <span
                  style={{
                    color: "#ffeb32",
                    fontSize: "40px",
                  }}
                >
                  Leaderboard
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  marginLeft: "15px",
                  marginBottom: "10px",
                  marginRight: "15px",
                  flexWrap: "wrap",
                }}
              >
                {variableParams.background === "rimac-background" && (
                  <img
                    alt=""
                    width={124}
                    height={30}
                    style={{ marginRight: "20px" }}
                    src={require("./assets/rimac_logo.png")}
                  />
                )}
                <img
                  alt="sportreact"
                  width={133}
                  height={28}
                  src={require("./assets/sportreact_logo.png")}
                />
              </div>
            </div>
          </div>
          <div
            className="example"
            style={{
              marginLeft: "45px",
              marginRight: "20px",
              maxHeight: "80%",
              overflow: "scroll",
              overflowX: "hidden",
            }}
          >
            <table
              style={{
                maxHeight: "100%",
                width: "-webkit-fill-available",
                marginLeft: "20px",
              }}
            >
              {dispalyResults.map((result, index) => {
                const splittedName = result.name.split(" ");
                const joinedName = splittedName
                  .map((namePart, index) => {
                    if (index === splittedName.length - 1) {
                      return namePart.toUpperCase();
                    } else return namePart;
                  })
                  .join(" ");

                return (
                  <tr
                    style={{
                      display: "flex",
                      borderRadius: "5px",
                      lineHeight: "28px",
                      fontSize: "20px",
                      ...(index === 0
                        ? {
                            color: "black",
                            backgroundColor: "#D8D8D8",
                          }
                        : {}),
                    }}
                  >
                    <td style={{ display: "flex", flex: 2 }}>
                      <div
                        style={{
                          textAlign: "end",
                          color: index === 0 ? undefined : "#FFEB32",
                          maxWidth: "45px",
                          minWidth: "45px",
                          marginRight: "5px",
                          borderRightColor: "#323232",
                          borderRightWidth: "2px",
                          borderRightStyle: index === 0 ? undefined : "solid",
                        }}
                      >
                        {index + 1}.{" "}
                      </div>
                      <div>{joinedName}</div>
                    </td>
                    <td
                      style={{
                        display: "flex",
                        flex: 1,
                        fontSize: "16px",
                        color: index === 0 ? undefined : "#878787",
                      }}
                    >
                      {result.description}
                    </td>
                    <td
                      style={{
                        display: "flex",
                        flex: 1,
                      }}
                    >
                      {formatToMinSecMs(result.duration)}
                    </td>
                    <td
                      style={{
                        minWidth: "70px",
                        textAlign: "end",
                        marginRight: "20px",
                        fontSize: "16px",
                        color: index === 0 ? undefined : "#FFF",
                      }}
                    >
                      {index === 0
                        ? "CHAMP"
                        : formatDifference(result.duration - fastestDuration)}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        </RightBlock>
      </SubContainer>
      {!!lastResult && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "80%",
            marginTop: "2px",
          }}
        >
          <div
            style={{
              display: "flex",
              flex: 2,
              justifyContent: "space-between",
            }}
          >
            <div>
              Last result:
              <span
                style={{
                  textAlign: "end",
                  color: "#FFEB32",
                  maxWidth: "45px",
                  minWidth: "25px",
                  marginRight: "5px",
                }}
              >
                {" "}
                {lastIndex + 1}{" "}
              </span>
              <span>
                {" "}
                {lastResult?.name
                  ?.split(" ")
                  ?.map((namePart, index) => {
                    if (index === lastResult.name?.split(" ").length - 1) {
                      return namePart.toUpperCase();
                    } else return namePart;
                  })
                  ?.join(" ")}
              </span>
            </div>
            <div
              style={{
                fontSize: "16px",
                color: "#878787",
              }}
            >
              {" "}
              {lastResult?.description ?? "Marketing department"}
            </div>
            <div> {formatToMinSecMs(lastResult?.duration ?? 0)}</div>
            <div
              style={{
                minWidth: "70px",
                textAlign: "end",
                marginRight: "20px",
                fontSize: "16px",
                color: "#FFF",
              }}
            >
              {formatDifference(lastResult?.duration - fastestDuration)}
            </div>
          </div>
          <LinkDiv>
            <a href="https://sportreact.com">sportreact.com</a>
          </LinkDiv>
        </div>
      )}
    </Container>
  );
};

function formatToMinSecMs(value) {
  const minutes = Math.floor(value / 60000);
  let rest = value % 60000;
  const seconds = Math.floor(rest / 1000);
  rest = rest % 1000;
  const ms = Math.round(rest);

  return `${minutes > 0 ? minutes : "00"}:${
    seconds > 0 ? (seconds >= 10 ? seconds : "0" + seconds) : "00"
  }.${ms >= 100 ? ms : ms >= 10 ? "0" + ms : "00" + ms}`;
}

function formatDifference(value) {
  const seconds = Math.floor(value / 1000);
  let ms = Math.round(value % 1000);
  return `+${seconds}.${ms >= 100 ? ms : ms >= 10 ? "0" + ms : "00" + ms}`;
}
